export default "__VITE_ASSET__c321cfd1__"